import React from "react";
import { Box, Typography } from "@material-ui/core";
import theme from "../../../theme";

// SectionCard — wrapper chuẩn cho mỗi khối nội dung trong modal.
// Thiết kế đồng bộ với InstitutionalProject + ScientificResearch:
//   - Border 1px #bcbcbc, bo góc 4px
//   - Header bg #ececec, padding 8px 16px, có icon + tiêu đề IN HOA màu primary
//   - Body padding 16px (padding={2})
//
// Props:
//   - icon:     React element (ví dụ <Info />)
//   - title:    string (sẽ hiển thị UPPERCASE) HOẶC ReactNode (render thẳng,
//               cho phép gắn chip/badge bên cạnh — dùng ở SettingForm).
//   - marginTop: số — khoảng cách với block phía trên (mặc định 2)
//   - children: nội dung body
export default function SectionCard({ icon, title, marginTop = 2, children }) {
  const renderTitle = () => {
    if (typeof title === "string") return <b>{title.toUpperCase()}</b>;
    return title; // ReactNode — render as-is, caller tự lo style
  };
  return (
    <Box border="solid 1px #bcbcbc" borderRadius={4} marginTop={marginTop}>
      <Box
        display="flex"
        alignItems="center"
        bgcolor="#ececec"
        padding="8px 16px"
        borderBottom="solid 1px #bcbcbc"
        style={{ borderTopLeftRadius: 4, borderTopRightRadius: 4 }}
      >
        {icon &&
          React.cloneElement(icon, {
            style: {
              ...(icon.props?.style || {}),
              marginRight: 12,
              color: theme.palette.primary.main,
            },
          })}
        <Typography
          component="div"
          variant="h6"
          style={{ color: theme.palette.primary.main, flex: 1 }}
        >
          {renderTitle()}
        </Typography>
      </Box>
      <Box padding={2}>{children}</Box>
    </Box>
  );
}
